exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2KoNo {\n  margin-left: -15px;\n  margin-right: -15px;\n  margin-top: 10px;\n}\n", ""]);

// Exports
exports.locals = {
	"list": "_2KoNo"
};